import script from "./inventoryCategories.vue?vue&type=script&setup=true&lang=ts"
export * from "./inventoryCategories.vue?vue&type=script&setup=true&lang=ts"

import "./inventoryCategories.vue?vue&type=style&index=0&id=dfa8cc3c&lang=scss"

const __exports__ = script;

export default __exports__